import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSubdomain = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 18 18",
	stroke: "currentColor",
	fill: "white",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0_1249_86943)",
			children: [
				/* @__PURE__ */ _jsx("rect", {
					y: 2,
					width: 16,
					height: 16,
					rx: 8,
					stroke: "none"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M7.99967 16.6666C11.6816 16.6666 14.6663 13.6818 14.6663 9.99992C14.6663 6.31802 11.6816 3.33325 7.99967 3.33325C4.31778 3.33325 1.33301 6.31802 1.33301 9.99992C1.33301 13.6818 4.31778 16.6666 7.99967 16.6666Z",
					strokeLinecap: "round",
					strokeLinejoin: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M7.99967 3.33325C6.28783 5.13069 5.33301 7.51775 5.33301 9.99992C5.33301 12.4821 6.28783 14.8691 7.99967 16.6666C9.71152 14.8691 10.6663 12.4821 10.6663 9.99992C10.6663 7.51775 9.71152 5.13069 7.99967 3.33325Z",
					strokeLinecap: "round",
					strokeLinejoin: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M1.33301 10H14.6663",
					strokeLinecap: "round",
					strokeLinejoin: "round"
				})
			]
		}),
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip1_1249_86943)",
			children: [
				/* @__PURE__ */ _jsx("rect", {
					x: 7,
					width: 11,
					height: 11,
					rx: 5.5,
					stroke: "none"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M12.5 10C14.9853 10 17 7.98528 17 5.5C17 3.01472 14.9853 1 12.5 1C10.0147 1 8 3.01472 8 5.5C8 7.98528 10.0147 10 12.5 10Z",
					strokeLinecap: "round",
					strokeLinejoin: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M12.5 1C11.5371 2.21327 11 3.82453 11 5.5C11 7.17547 11.5371 8.78673 12.5 10C13.4629 8.78673 14 7.17547 14 5.5C14 3.82453 13.4629 2.21327 12.5 1Z",
					strokeLinecap: "round",
					strokeLinejoin: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M8 5H17",
					strokeLinecap: "round",
					strokeLinejoin: "round"
				})
			]
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [/* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_1249_86943",
			children: /* @__PURE__ */ _jsx("rect", {
				y: 2,
				width: 16,
				height: 16,
				rx: 8,
				stroke: "none"
			})
		}), /* @__PURE__ */ _jsx("clipPath", {
			id: "clip1_1249_86943",
			children: /* @__PURE__ */ _jsx("rect", {
				x: 7,
				width: 11,
				height: 11,
				rx: 5.5,
				stroke: "none"
			})
		})] })
	]
});
export default SvgSubdomain;
